import {
  Zap, Home, Plane, TrendingUp, TrendingDown, ArrowLeftRight, Shield, Equal, Clock, Target,
  type LucideIcon,
} from "lucide-react";

const MAP: Record<string, LucideIcon> = {
  Zap, Home, Plane, TrendingUp, TrendingDown, ArrowLeftRight, Shield, Equal, Clock, Target,
};

export function MarketIcon({ name, className }: { name: string; className?: string }) {
  const Cmp = MAP[name] || Target;
  return <Cmp className={className} />;
}
